import { CLEANUP_STATE } from '../actions/shared'
import {
    FETCH_PRINTERS_SUCCEEDED,
    FETCH_PRINTERS_FAILED,
    PRINTER_DISCOVERED,
    PRINTER_CONNECTION_CHANGED,
  } from '../actions/printer'

import PrinterModel from '../models/Printer'

  const initialState = {
    byId: {},
  }

  export default (state = initialState, action) => {
    switch (action.type) {
      case CLEANUP_STATE: {
        const localPrinter = state.byId?.local ?? {}

        return {
          ...initialState,
          byId: {
            local: localPrinter,
          }
        }
      }

      case FETCH_PRINTERS_SUCCEEDED: {
        let localPrinter = {}

        if (state.byId?.local) {
          localPrinter = { local: state.byId.local }
        }

        return {
          ...state,
          byId: {
            ...(action?.payload?.byId ?? {}),
            ...localPrinter,
          }
        }
      }

      case FETCH_PRINTERS_FAILED:
        return state

      case PRINTER_DISCOVERED: {
        const printer = PrinterModel({
          uuid: 'local',
          name: action.payload.printer ?? 'Local Printer',
          ...(state.byId.local ?? {})
        })

        const newState = {
          ...state,
          byId: {
            ...state.byId,
            local: printer,
          }
        }

        console.log('%c discoveredPrinters:: local DB', 'font-size: 16px; font-weight: bold;')
        console.log(newState.byId.local)

        return newState
      }

      case PRINTER_CONNECTION_CHANGED: {
        const newState = {
          ...state,
          byId: {
            ...state.byId,
            local: {
              ...state.byId.local,
              state: action.payload.state,
            }
          }
        }

        console.log('%c printerConnectionState:: local DB', 'font-size: 16px; font-weight: bold;')
        console.log(newState.byId.local)

        return newState
      }

      default:
        return state
    }
  }